import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/settings/page";

export const Route = createFileRoute("/clients/$clientId/dashboard/settings")({
  component: Page,
});
